module.exports = __webpack_public_path__ + "static/media/new_message_icon.0a1c985c.svg";